import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../redux/store';
import { MessageBoxContainer } from './messageBoxContainer';
export const MessageBoxesContainer = () => {
    const messageBoxes = useAppSelector((state) => state.messageBoxes.messageBoxes);
    if (!messageBoxes.length) {
        return null;
    }
    const messageBox = messageBoxes[0];
    return _jsx(MessageBoxContainer, { messageBox: messageBox });
};
